import $ from 'jquery';
import * as types from '../actions/actionTypes'
import { config } from '../constants';
window.jQuery = $;
require('signalr');


const signalRConnection = $.hubConnection(config.SignalR_URL, { useDefaultPath: false });

export function signalRRegistration(store) {
    signalRConnection.start({ withCredentials: false })
        .done(function () {
            console.log('Now connected, connection ID=' + signalRConnection.id);
        })
        .fail(function () {
            console.log('Could not connect');
            //window.alert('Unable to start signalR connection....');
        });

    var notificationHubProxy = signalRConnection.createHubProxy('TCMHub');

    notificationHubProxy.on('ComentatorTicker', function (value) {
        if (value.toLowerCase() === "update") {
            store.dispatch({
                type: types.UPDATE_PAGE,
                value
            });
        }
    });

    notificationHubProxy.on('updatePage', function (value) {
        store.dispatch({
            type: types.UPDATE_PAGE,
            value
        });
    });

    notificationHubProxy.on('sethomeline', function (place, bib, name, time, nation, distance, rank, speed, diff, heatname) {
        store.dispatch({
            type: types.live.GET_HOMELINE_SUCCESS,
            data: {
                place, bib, name, time, nation, distance, rank, speed, diff, heatname
            }

        });
    });

    notificationHubProxy.on('setbackline', function (place, bib, name, time, nation, distance, rank, speed, diff, heatname) {
        store.dispatch({
            type: types.live.GET_BACKLINE_SUCCESS,
            data: {
                place, bib, name, time, nation, distance, rank, speed, diff, heatname
            }
        });
    });
    // notificationHubProxy.on('send1', function (id, value) {
    //     store.dispatch({
    //         type: types.GET_Data1,
    //         data: {
    //             id: id,
    //             value: value
    //         }
    //     });
    // });
    // notificationHubProxy.on('send2', function (id, value) {
    //     store.dispatch({
    //         type: types.GET_Data2,
    //         data: {
    //             id: id,
    //             value: value
    //         }
    //     });
    // });
}
